module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: {
      __error: _vm.vError
    }
  }, [(_vm.label) ? _c('label', {
    staticClass: "__form-label",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label)), (_vm.required) ? _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), (_vm.isInput) ? _c('span', {
    staticClass: "__form-input__container"
  }, [(_vm.appendPhone) ? _c('span', {
    staticClass: "__form-input__append"
  }, [_vm._v("+7")]) : _vm._e(), (!_vm.mask) ? _c('input', {
    key: _vm.tag,
    staticClass: "__form-input",
    class: _vm.classes,
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.input,
      "blur": _vm.blur,
      "focus": function($event) {
        return _vm.$emit("focus")
      }
    }
  }) : _c('MaskedInput', {
    key: _vm.tag,
    staticClass: "__form-input",
    class: _vm.classes,
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "mask": _vm.mask,
      "value": _vm.value,
      "name": _vm.name
    },
    on: {
      "input": _vm.input,
      "blur": _vm.blur
    }
  })], 1) : _vm._e(), (_vm.vError) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e(), (_vm.addText) ? _c('div', {
    staticClass: "add_text"
  }, [_vm._v(_vm._s(_vm.addText))]) : _vm._e(), (_vm.$slots.link) ? _c('div', {
    staticClass: "link"
  }, [_vm._t("link")], 2) : _vm._e(), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6486d4c1","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Input.vue
// module id = 80c3362c4ef13d626418
// module chunks = 89